export enum AnalyticsEvent {
  PAGE_VIEW = "page_View",
  PAGE_ENGAGEMENT = "page_engagement",
  NAV_HOME = "nav_home",
  NAV_OFFERINGS = "nav_offerings",
  NAV_CO_INVESTMENT = "nav_co_investment",
  NAV_CAPITAL_ACTIVITY = "nav_capital_activity",
  NAV_DOCUMENTS = "nav_documents",
  NAV_RESOURCES = "nav_resources",
  AUTH_OKTA_AUTHORIZE = "auth_okta_authorize",
  AUTH_LOGIN_SUCCESS = "auth_login_success",
  AUTH_LOGOUT = "auth_logout",
  FUND_SUBSCRIBE = "fund_subscribe",
  FUND_VIEW_DETAILS = "fund_view_details",
  FUND_LEARNING = "fund_learning",
  FUND_HOLDINGS_DOWNLOAD = "fund_holdings_download",
  DOCUMENT_DOWNLOAD = "document_download",
  DOCUMENT_VIEW = "document_view",
  REPORT_DOWNLOAD = "report_download",
  REPORT_VIEW = "report_view",
  // Co-Investment NDA Events
  COINVEST_NDA_OPENED = "coinvest_nda_opened",
  COINVEST_NDA_SIGNED = "coinvest_nda_signed",
  COINVEST_NDA_DISMISSED = "coinvest_nda_dismissed",
  COINVEST_DEAL_REJECTED = "coinvest_deal_rejected",
  COINVEST_NDA_DOWNLOADED = "coinvest_nda_downloaded",
  COINVEST_DATA_ROOM_ACCESSED = "coinvest_data_room_accessed",
  COINVEST_OUTREACH_EMAIL_SENT = "coinvest_outreach_email_sent",
  COINVEST_NDA_SIGNED_BY_GP = "coinvest_nda_signed_by_gp",
}

export enum AnalyticsPage {
  HOME = "page_home",
  OFFERINGS = "page_offerings",
  CO_INVESTMENTS = "page_co_investments",
  CAPITAL_ACTIVITY = "page_capital_activity",
  INVESTOR_DOCUMENTS = "page_documents",
  RESOURCES = "page_resources",
  REPORTING = "page_reporting",
  REPORTING_EDV = "page_reporting_edv",
  ANALYTICS = "page_analytics",
  // GP Portal pages
  GP_TASKS = "page_gp_tasks",
  GP_CASES = "page_gp_cases",
  GP_CO_INVESTMENT = "page_gp_co_investment",
  GP_ANALYTICS = "page_gp_analytics",
  GP_FUNDS = "page_gp_funds",
  GP_FUND_DETAILS = "page_gp_fund_details",
  GP_FUND_SUBSCRIPTIONS = "page_gp_fund_subscriptions",
  GP_FUND_INVESTMENTS = "page_gp_fund_investments",
  GP_FUND_OPPORTUNITIES = "page_gp_fund_opportunities",
  GP_FUND_CARRIED_INTEREST = "page_gp_fund_carried_interest",
  GP_FUND_DOCUMENTS = "page_gp_fund_documents",
  GP_FUND_CAPITAL_ACTIVITY = "page_gp_fund_capital_activity",
  GP_INVESTORS = "page_gp_investors",
  GP_INVESTOR_OVERVIEW = "page_gp_investor_overview",
  GP_INVESTOR_DASHBOARD = "page_gp_investor_dashboard",
  GP_INVESTOR_OFFERINGS = "page_gp_investor_offerings",
  GP_INVESTOR_CAPITAL_ACTIVITY = "page_gp_investor_capital_activity",
  GP_INVESTOR_DOCUMENTS = "page_gp_documents",
  GP_INVESTOR_REPORTING = "page_gp_investor_reporting",
  GP_HELP_CENTRE = "page_gp_help_centre",
  GP_SUBSCRIPTIONS_TRACKER = "page_gp_subscriptions_tracker",
  GP_SETTINGS = "page_gp_settings",
}
